import { useEffect, useState } from 'react';

import { listStandaloneCharges, StandaloneChargeDTO } from '../../../services/standalone-charges';
import { dangerNotification } from '../../../services/notification';
import { unmaskCpfOrCnpj } from '../../../services/masks';

import { FiltersState } from '../types';

type Params = {
  initialFilters: FiltersState;
  enabled: boolean;
};

export const useStandaloneChargesList = ({ initialFilters, enabled }: Params) => {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState<StandaloneChargeDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState<FiltersState>(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState<FiltersState>(initialFilters);

  const loadData = async (page = currentPage, pageFilters = appliedFilters) => {
    setIsLoading(true);
    try {
      const payerFilter = pageFilters.type === 'payer' ? pageFilters.argument : '';
      const documentFilter =
        pageFilters.type === 'document' ? unmaskCpfOrCnpj(pageFilters.argument) : '';
      const emailFilter = pageFilters.type === 'email' ? pageFilters.argument : '';

      const response = await listStandaloneCharges({
        page,
        limit: 10,
        estateId: pageFilters.estateId || undefined,
        estateUnitId: pageFilters.estateUnitId || undefined,
        payer: payerFilter || undefined,
        document: documentFilter || undefined,
        email: emailFilter || undefined,
        status: pageFilters.status || undefined,
        startDate: pageFilters.startDate || undefined,
        endDate: pageFilters.endDate || undefined
      });
      setItems(response.data || []);
      setTotal(response.count || 0);
    } catch (error) {
      dangerNotification('Erro', 'Não foi possível carregar cobranças.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) return;
    loadData(currentPage, appliedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, appliedFilters, enabled]);

  const handleSearch = () => {
    setCurrentPage(1);
    setAppliedFilters(filters);
  };

  const clearFilters = () => {
    setFilters(initialFilters);
    setCurrentPage(1);
    setAppliedFilters(initialFilters);
  };

  return {
    isLoading,
    items,
    total,
    currentPage,
    setCurrentPage,
    filters,
    setFilters,
    appliedFilters,
    setAppliedFilters,
    loadData,
    handleSearch,
    clearFilters
  };
};

